import { create } from 'zustand';
import { leaveForTelemetryDeniedLogin } from '@/lib/privacy/auth-document';

interface AuthModalState {
  isOpen: boolean;
  tab: 'sign-in' | 'sign-up';
  successMessage?: string;
  showSuccess: boolean;
}

interface ModalState {
  authModal: AuthModalState;
  
  openAuthModal: (tab?: 'sign-in' | 'sign-up') => void;
  closeAuthModal: () => void;
  showAuthSuccess: (message: string) => void;
  resetAuthModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  authModal: {
    isOpen: false,
    tab: 'sign-in',
    showSuccess: false,
    successMessage: undefined
  },

  openAuthModal: (tab = 'sign-in') => {
    if (leaveForTelemetryDeniedLogin(tab)) return;
    set((state) => ({
      authModal: {
        ...state.authModal,
        isOpen: true,
        tab,
        showSuccess: false,
        successMessage: undefined
      }
    }));
  },

  closeAuthModal: () =>
    set((state) => ({
      authModal: {
        ...state.authModal,
        isOpen: false,
        showSuccess: false,
        successMessage: undefined
      }
    })),

  showAuthSuccess: (message: string) =>
    set((state) => ({
      authModal: {
        ...state.authModal,
        showSuccess: true,
        successMessage: message
      }
    })),

  resetAuthModal: () =>
    set({
      authModal: {
        isOpen: false,
        tab: 'sign-in',
        showSuccess: false,
        successMessage: undefined
      }
    })
})); 